<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Send Self Service Invitation</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent" style="position: relative; width: 100%;"></validation-results>
    <form [formGroup]="form">
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Service Type</label>
                    <select class="mvd_form-control" formControlName="assistedSelfServiceTypeId">
                        <option *ngFor="let serviceType of serviceTypes" value="{{serviceType.id}}">{{serviceType.assistedSelfServiceTypeDisplayValue}}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="form.controls.assistedSelfServiceTypeId.hasError('required') && form.controls.assistedSelfServiceTypeId.touched">Service Type is required</div>
                    </div>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label>Expires In</label>
                    <select class="mvd_form-control" formControlName="daysExpiresIn">
                        <option value="1">1 day</option>
                        <option value="2">2 days</option>
                        <option value="3">3 days</option>
                        <option value="4">4 days</option>
                    </select>
                </div>
            </div>

            <h3 [ngClass]="{'required': isContactMethodRequired }" [title]="isContactMethodRequired ? '* Required' : 'Preferred Contact Method'">Preferred Contact Method
            </h3>
            <div class="row">
                <div class="col-11 col-sm-6 mvd_form-group">
                    <label class="mvd_label--radio" for="preferEmail"><input type="radio" name="notificationType" formControlName="notificationType" value="1" />&nbsp;Email</label>
                    <div class="container--indent">
                        <input class="mvd_form-control" id="preferEmail" type="text" placeholder="contact@email.com" autocomplete="off" formControlName="email" maxlength="256" />
                        <control-validation-messages control="email"></control-validation-messages>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-11 col-sm-5 col-md-4 mvd_form-group">
                    <label class="mvd_label--radio" for="preferPhone"><input type="radio" name="notificationType" formControlName="notificationType" value="2" />&nbsp;Phone Number (Text Message)</label>
                    <div class="container--indent">
                        <p-inputMask styleClass="mvd_form-control" mask="999-999-9999" placeholder="xxx-xxx-xxxx" formControlName="phoneNumber"></p-inputMask>
                        <div class="mvd_alert__validation">
                            <div class="mvd_alert__rule" *ngIf="form.controls.phoneNumber.hasError('required') && form.controls.phoneNumber.touched">Phone Number is required</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label for="message">Message</label>
                    <textarea class="mvd_form-control" formControlName="message" maxlength="256" rows="4"></textarea>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(form.valid && form.dirty)" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="saveInvitation()"></mvm-spinner-btn>
    </div>
</div>